import React from 'react';
import CasinoContainer from '../../../../components/casino/CasinoContainer';
import AuthorizationSettingContent from './AuthorizationSettingContent';

export default function AuthorizationSetting() {
  return (
    <CasinoContainer title={'Website Login / mailings'}>
      <AuthorizationSettingContent />
    </CasinoContainer>
  );
}
